const ViewTTStore = {
    data: null,
    detailsTableConfig: null,
    dateRangeConfig: null,
    filter: null,
    chartSectionConfig: null,
    weekStartDay: null,
    viewerId: -1,
    selectedUserId: -1,
    userInfo: null,
    dateFormat: null,
    assignedCPList: null,
    assignedCPMaps: null,
    generatedPDF: null,
    fileName: "file.pdf",
    printNumberOfPages: null,
    printParametersForSave: null,
    printParametersForGenerate: null,
    users: null,
    groups: null,
    needToRenderUsersSelector: false,
    balancesData: null,
    balancesViewerConfig: null,
    formatterConfig: null,
    cptMaps: {
        customersById: {},
        projectsById: {},
        tasksById: {}
    },
    //TODO maybe need find another place for enabled features (actual)
    enabledFeatures: null,
    mergedCpList: null,

    // to backup settings for load data or any other needs
    backup: {},
    // this field functionally also used for backup
    // we restore balance viewer date by this value
    balancesViewerDate: null,

    getData: function()
    {
        return this.data
    },

    setData: function(data, cptMaps)
    {
        this.data = data;
        this.cptMaps = cptMaps;
        $(this).trigger("dataChange");
    },

    getCptMaps: function()
    {
        return this.cptMaps;
    },

    getCustomer: function(id)
    {
        return this.cptMaps.customersById[id];
    },

    getProject: function(id)
    {
        return this.cptMaps.projectsById[id];
    },

    getTask: function(id)
    {
        return this.cptMaps.tasksById[id];
    },

    updateTask: function(task)
    {
        if (!this.getTask(task.id)) return;
        this.cptMaps.tasksById[task.id] = {
            ...this.getTask(task.id),
            ...task
        };
    },

    setProject: function(project) {
        this.cptMaps.projectsById[project.id] = project
    },

    setCustomer: function(customer) {
        this.cptMaps.customersById[customer.id] = customer
    },

    getChartSectionConfig: function()
    {
        return this.chartSectionConfig;
    },

    setChartSectionConfig: function(chartSectionConfig)
    {
        this.chartSectionConfig = chartSectionConfig;
        $(this).trigger("chartSectionConfigChange");
    },

    getDetailsTableConfig: function()
    {
        return this.detailsTableConfig;
    },

    setDetailsTableConfig: function(detailsTableConfig)
    {
        this.detailsTableConfig = detailsTableConfig;
        $(this).trigger("detailsTableConfigChange");
    },

    setDateRangeConfig: function(dateRangeConfig)
    {
        this.dateRangeConfig = dateRangeConfig;
        $(this).trigger("dateRangeConfigChange");
    },

    getDateRangeConfig: function()
    {
        return this.dateRangeConfig;
    },

    setFilter: function(filter)
    {
        this.filter = filter;
        $(this).trigger("filterChange");
    },

    getFilter: function()
    {
        return this.filter;
    },

    getWeekStartDay: function()
    {
        return this.weekStartDay;
    },

    setWeekStartDay: function(weekStartDay)
    {
        this.weekStartDay = weekStartDay;
    },

    setViewerId: function(viewerId)
    {
        this.viewerId = viewerId;
    },

    getViewerId: function()
    {
        return this.viewerId;
    },

    setSelectedUserId: function(userId)
    {
        this.selectedUserId = userId;
        $(this).trigger("selectedUserIdChange");
    },

    getSelectedUserId: function()
    {
        return this.selectedUserId;
    },

    setDateFormat: function(dateFormat)
    {
        this.dateFormat = dateFormat;
    },

    getDateFormat: function()
    {
        return this.dateFormat;
    },

    setAssignedCPList: function(cpList)
    {
        this.assignedCPList = cpList;
    },

    getAssignedCPList: function()
    {
        return this.assignedCPList;
    },

    setAssignedCPMaps: function(cpMaps)
    {
        this.assignedCPMaps = cpMaps;
    },

    getAssignedCPMaps: function()
    {
        return this.assignedCPMaps;
    },

    setGeneratedPDF: function(generatedPDF)
    {
        this.generatedPDF = generatedPDF;
        $(this).trigger("generatedPDFChange");
    },

    getGeneratedPDF: function()
    {
        return this.generatedPDF;
    },

    setPDFFileName: function(fileName)
    {
        this.fileName = fileName;
    },

    getPDFFileName: function()
    {
        return this.fileName;
    },

    getPrintParametersForSave: function()
    {
        return this.printParametersForSave;
    },

    setPrintParametersForSave: function(printParametersForSave)
    {
        this.printParametersForSave = printParametersForSave;
        $(this).trigger("printParametersForSaveChange");
    },

    getPrintParametersForGenerate: function()
    {
        return this.printParametersForGenerate;
    },

    setPrintParametersForGenerate: function(printParametersForSave)
    {
        this.printParametersForGenerate = printParametersForSave;
    },

    setUsersAndGroups: function(users, groups)
    {
        this.users = users;
        this.groups = groups;
    },

    getUsers: function()
    {
        return this.users;
    },

    getGroups: function()
    {
        return this.groups;
    },

    setNeedToRenderUsersSelector: function(needToRender)
    {
        this.needToRenderUsersSelector = needToRender;
    },

    isNeedToRenderUsersSelector: function()
    {
        return this.needToRenderUsersSelector;
    },

    setBalancesData: function(balancesData)
    {
        this.balancesData = balancesData;
        $(this).trigger("balancesDataChange");
    },

    getBalancesData: function()
    {
        return this.balancesData;
    },

    setBalancesViewerConfig: function(balancesViewerConfig)
    {
        this.balancesViewerConfig = balancesViewerConfig;
    },

    getBalancesViewerConfig: function()
    {
        return this.balancesViewerConfig;
    },

    setFormatterConfig: function(formatterConfig)
    {
        this.formatterConfig = formatterConfig;
    },

    getFormatterConfig: function()
    {
        return this.formatterConfig;
    },

    getEnabledFeatures: function()
    {
        return this.enabledFeatures;
    },

    setEnabledFeatures: function(enabledFeatures)
    {
        this.enabledFeatures = enabledFeatures;
    },

    setMergedCp: function(mergedCpList)
    {
        this.mergedCpList = mergedCpList;
    },

    getMergedCpList: function()
    {
        return this.mergedCpList;
    },

    setUserInfo: function(userInfo)
    {
        this.userInfo = userInfo;
    },

    getUserInfo: function()
    {
        return this.userInfo;
    },

    /**
     * Backup stable state of configuration for loading data
     */
    backupDataConfig: function()
    {
        this.backup.selectedUserId = this.getSelectedUserId();
        this.backup.dateRangeConfig = this.getDateRangeConfig();
        this.backup.filter = this.getFilter();
    },

    /**
     * Restoring configuration for loading data and notify about it
     */
    restoreDataConfig: function()
    {
        this.setSelectedUserId(this.backup.selectedUserId);
        this.setDateRangeConfig(this.backup.dateRangeConfig);
        this.setFilter(this.backup.filter);

        $(this).trigger("dataConfigRestored");
    },

    setBalancesViewerDate: function(date)
    {
        this.balancesViewerDate = date;
    },

    getBalancesViewerDate: function()
    {
        return this.balancesViewerDate;
    },
    
    getSelectedUser: function()
    {
        return _.find(this.users, _.bind(function(user) {return user.id == this.selectedUserId}, this));
    },
};

export default ViewTTStore;


// WEBPACK FOOTER //
// ./web/js/user/viewtt/ViewTTStore.js